import { useState } from "react";
import Login from "./components/Login";
import Register from "./components/Register";
import { useSession } from "../../hooks/useSession";
import { Navigate, useNavigate } from "react-router-dom";
import AuthLayout from "../../layout/AuthLayout";

export default function AuthPage() {
  const [isLoading, setLoading] = useState<boolean>(false);
  const [screen, setScreen] = useState<"register" | "login">("login");
  const { isAuthenticated } = useSession();
  const navigate = useNavigate();

  if (isAuthenticated) {
    return <Navigate to="/home" replace />;
  }

  return (
    <AuthLayout
      title={screen === "login" ? "Entrar" : "Criar conta"}
      subtitle={
        screen === "login"
          ? "Acesse suas avaliações de praças e continue o trabalho de campo."
          : "Preencha seus dados para solicitar acesso à ferramenta."
      }
    >
      {screen === "login" && (
        <Login isLoading={isLoading} setLoading={setLoading}>
          <div className="mt-2 flex flex-col gap-3 text-center text-sm">
            <button
              type="button"
              className="font-semibold text-primary hover:underline"
              disabled={isLoading}
              onClick={() => navigate("/password-reset/request")}
            >
              Esqueci minha senha
            </button>
            <p className="text-muted">
              Ainda não tem conta?{" "}
              <button
                type="button"
                className="font-semibold text-primary hover:underline"
                disabled={isLoading}
                onClick={() => setScreen("register")}
              >
                Cadastre-se
              </button>
            </p>
          </div>
        </Login>
      )}
      {screen === "register" && (
        <Register isLoading={isLoading} setLoading={setLoading}>
          <button
            type="button"
            className="mt-4 w-full text-center text-sm font-semibold text-primary hover:underline"
            disabled={isLoading}
            onClick={() => setScreen("login")}
          >
            Já tenho conta — entrar
          </button>
        </Register>
      )}
    </AuthLayout>
  );
}
